import moment from 'moment';
import { Md5 } from 'ts-md5/dist/md5';
import { User } from '../types';
import sign from 'jwt-encode';
import { IDataTableHeader } from '../types';

export default class Transformation {
  public static parseSigfoxId(sigfoxId: string): string {
    sigfoxId = sigfoxId.trim();
    return sigfoxId.replace(/^0+/, '').toUpperCase();
  }
  public static md5(input: string): string {
    return (Md5.hashStr(input) as string);
  }
  public static hashOrgSlug(slug: string): string {
    return Transformation.md5(slug).substr(0, 8);
  }

  public static createAuthorizerJWT(user: User, permissions: string[], secret: string): string {
    return sign({
      userId: user.id.toString(),
      userEmail: user.email,
      user: JSON.stringify(user),
      permissions: JSON.stringify({
        '*': {
          slug: null,
          projects: {
            '*': {
              permissions,
            },
          },
        },
      }),
    }, secret);
  }

  public static tableFiltersToMap(item: any, skipList: string[] = []): { [key: string]: { [key: string]: boolean } } {
    const result: { [key: string]: { [key: string]: boolean } } = {};
    if (item) {
      let items: any[];
      if (!(item instanceof Array)) {
        items = Object.keys(item);
      } else {
        items = item;
      }
      for (const key of items) {
        if (skipList.includes(key)) {
          continue;
        }
        if (!(item[key] instanceof Array)) {
          result[key] = item[key];
          continue;
        }

        result[key] = {};

        item[key].forEach((value: string | number) => {
          result[key][value] = true;
        });
      }
    }
    return result;
  }

  public static timeFiltersToMap(item: any, skipList: string[] = []): { [key: string]: { start: Date | null; end: Date | null } } {
    const result: { [key: string]: { start: Date | null; end: Date | null } } = {};
    if (item) {
      for (const key in item) {
        if (skipList.includes(key)) {
          continue;
        }

        const dates = item[key];
        if (dates instanceof Array && dates.length === 2) {
          const sortedDates = dates.sort((a, b) => new Date(a).getTime() - new Date(b).getTime());
          const [start, end] = sortedDates;
          result[key] = {
            start: new Date(new Date(start).setHours(0, 0, 0, 0)),
            end: new Date(new Date(end).setHours(23, 59, 59, 0)),
          };
        } else if (dates instanceof Array && dates.length === 0) {
          result[key] = {
            start: null,
            end: null,
          };
        }
      }
    }
    return result;
  }

  public static timeFilterMapToQueryString(timeFilters: { [key: string]: { start: Date | null; end: Date | null }}): string {
    return Object.entries(timeFilters).map(([key, { start, end }]) => {
      if (!start || !end) {
        return `${key}=[]`;
      } else {
      return `${key}=[${start.getTime()},${end.getTime()}]`;
      }
    }).join('&');
  }
  public static filterMapToQueryString(filters: Record<string, Record<string, boolean>>): string {
    return Object.entries(filters).map(([key, filter]) => {
      return isNaN(Number(filter)) ?
        `${key}=[${ typeof filter === 'object' ? Object.keys(filter).map((filterValue) => filterValue) : filter}]` :
        `${key}=[${Object.keys(filter).map((filterValue) => Number(filterValue))}]`;

      }).join('&');
  }

  public static queryDataToExportPayload(filters: Record<string, string[]>): Record<string, number[]> {
    if (!filters) {
      return {};
    }

    return Object.entries(filters).reduce((map: Record<string, number[]>, [key, filterValues]: [string, string[]]) => {
      map[key] = filterValues.map((id) => Number(id));
      return map;
      }, {});
  }

  public static setTableFilterValues(headers: IDataTableHeader[], columnFilters: any, queryKeys?: string[]) {
    headers.forEach((header: any) => {
      if (!header.filterable) {
        return;
      }

      if (header.queryKey && columnFilters && columnFilters[header.queryKey]) {
        header.allowedFilterValues = columnFilters[header.queryKey];
        header.sortable = false;
      }
    });
  }
}
